import { render, staticRenderFns } from "./header.vue?vue&type=template&id=4bd8e3ee&scoped=true&"
var script = {}
import style0 from "./header.vue?vue&type=style&index=0&id=4bd8e3ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../mercari_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd8e3ee",
  null
  
)

export default component.exports